import RequestAttributeList from '@/components/RequestAttribute/RequestAttributeList'
import RequestAttributeForm from '@/components/RequestAttribute/RequestAttributeForm'

// Les deux bibliothèques du module Location pour compte relèvent de la même permission :
// côté client, la personne qui administre le catalogue LPC est celle qui traite les demandes.
let RequestAttributeRouter = [{
  path: '/request-attribute',
  name: 'RequestAttributeList',
  component: RequestAttributeList,
  meta: {
    title: 'Attributs de demande',
    requiresAuth: true,
    authorizations: ['location-for-account_index', 'desktop_access']
  }
}, {
  path: '/request-attribute/new',
  name: 'RequestAttributeNew',
  component: RequestAttributeForm,
  meta: {
    title: 'Nouvel attribut de demande',
    requiresAuth: true,
    authorizations: ['location-for-account_new', 'desktop_access']
  }
}, {
  path: '/request-attribute/:id/edit',
  name: 'RequestAttributeEdit',
  component: RequestAttributeForm,
  meta: {
    title: 'Modifier un attribut de demande',
    requiresAuth: true,
    authorizations: ['location-for-account_edit', 'desktop_access']
  }
}]

export default RequestAttributeRouter



// WEBPACK FOOTER //
// ./src/components/RequestAttribute/router.js